/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F5_QInputs */

const en_mk_sec_pg_f5_q = /** @type {(inputs: Mk_Sec_Pg_F5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What about Indonesia’s personal data protection law?`)
};

const id_mk_sec_pg_f5_q = /** @type {(inputs: Mk_Sec_Pg_F5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana dengan UU Perlindungan Data Pribadi?`)
};

/**
* | output |
* | --- |
* | "What about Indonesia’s personal data protection law?" |
*
* @param {Mk_Sec_Pg_F5_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f5_q = /** @type {((inputs?: Mk_Sec_Pg_F5_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F5_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f5_q(inputs)
	return en_mk_sec_pg_f5_q(inputs)
});